import { Table } from "react-bootstrap";
import { IGeodeticLocation } from "../../dto/IGeodeticLocation";
import ImageModal from "../ImageModal";
import { Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import DownloadLink from "react-download-link";
import {useTranslation} from 'react-i18next';

const SinglePointDataTable = (props: {geodeticLocationData: IGeodeticLocation}) => {

    const geodeticLocationData = props.geodeticLocationData;
    const history = useHistory();
    const {t} = useTranslation();

    function getDegrees(coordinate: number) {
        let degree = Math.floor(coordinate);

        let minute = (coordinate - degree) * 60;

        let second = (minute - Math.floor(minute)) * 60; 

        return degree + "° " + Math.floor(minute) + "' " + parseFloat(second?.toString()).toFixed(5) + "\"";
    }

    const coordinatesSearchClicked = async (e: Event) => {
        e.preventDefault();

        if (geodeticLocationData.x && geodeticLocationData.y) {
            history.push("/multiplelocations/coords?xCoord=" + geodeticLocationData.x + "&yCoord=" + geodeticLocationData.y + "&radius=1000");
        }
    }

    function isYleminekuMudel() {
        /*tabeli veerus „too_kood_z“ ei ole numbrit „2955“, „11441“ või „11511“, „11357“, „11531“, „11372“
        või (veerus „artskode_z“ on number „61“ või „62“ ja samal ajal „aasta1_z“ on väiksem kui 2017)*/ 

        if (geodeticLocationData.tooKoodZ === 2955 || geodeticLocationData.tooKoodZ === 11441 || 
            geodeticLocationData.tooKoodZ === 11511 || geodeticLocationData.tooKoodZ === 11357 ||
            geodeticLocationData.tooKoodZ === 11531 || geodeticLocationData.tooKoodZ === 11372 ||
            ((geodeticLocationData.artskodeZ === 61 || geodeticLocationData.artskodeZ === 62) && geodeticLocationData.aasta1Z >= 2017)) {

            return false;
        }

        return true;
    }

    function generateInfoFile() {
        let resultString = t('resultId') + ":".padEnd(45) + geodeticLocationData.refNrId + "\r\n";
        resultString += t('resultName') + ":".padEnd(45) + geodeticLocationData.nimi + "\r\n";
        resultString += t('resultCode') + ":".padEnd(45) + geodeticLocationData.hnr + "-" + geodeticLocationData.snr + "-" + geodeticLocationData.lbn + "\r\n";
        resultString += t('resultPlaneTrCoords') + ":".padEnd(45) + getLestCoordinatesString() + "\r\n";
        resultString += t('resultGeodeticCoords') + ":".padEnd(45) + getDegrees(geodeticLocationData.b) + " " + getDegrees(geodeticLocationData.l) + " ( " + geodeticLocationData.b + " " + geodeticLocationData.l + " )\r\n";
        resultString += (geodeticLocationData.eh2000 || (geodeticLocationData.elk97 && geodeticLocationData.ellips)) ? t('resultNormHeight') + " EH2000:".padEnd(45) + getEh2000String() + "\r\n" : "";
        resultString += (geodeticLocationData.elk97) ? t('resultEllipsoidHeight') + " EUREF-EST97:".padEnd(45) + getElk97String() + "\r\n" : "";
        resultString += (geodeticLocationData.rkRkiirendus || geodeticLocationData.rkNvaliArvut || geodeticLocationData.rkBouguerArvut || geodeticLocationData.rkVabaArvut) ? t('resultGrAcceleration') + " EG2000:".padEnd(45) + getGravimetricMeasurements() + "\r\n" : "";
    
        resultString += t('resultCondition') + ":".padEnd(45) + geodeticLocationData.skoodTxt + " "
        resultString += (geodeticLocationData.skood && geodeticLocationData.skood !== 0) ? ((geodeticLocationData.ulevKuupaev && geodeticLocationData.ulevKuupaev !== "0" ) ? geodeticLocationData.ulevKuupaev : "") + " " + (geodeticLocationData.ulevFirma ? geodeticLocationData.ulevFirma : "") : "";
        resultString += (( geodeticLocationData.smarkus !== null && geodeticLocationData.smarkus.trim() !== "") ? " | " + geodeticLocationData.smarkus : "") + "\r\n";

        resultString += t('resultGNSSCompatibility') + ":".padEnd(45) + geodeticLocationData.gpsSobivTxt + "\r\n";
        resultString += (geodeticLocationData.tuupKood !== null && geodeticLocationData.tuupKood > 0) ? t('resultMarkerType') + ":".padEnd(45) + geodeticLocationData.tuupKood + "\r\n" : "";
        resultString += (geodeticLocationData.kaitsevoond !== null) ? t('resultProtectionArea') + ":".padEnd(45) + geodeticLocationData.kaitsevoondTxt + "\r\n" : "";
        resultString += (geodeticLocationData.asustusyksus !== null) ? t('resultSettlemUnit') + ":".padEnd(45) + geodeticLocationData.asustusyksus + "\r\n" : "";
        resultString += (geodeticLocationData.kirjeldus) ? t('resultSettlemUnit') + ":".padEnd(45) + geodeticLocationData.kirjeldus + "\r\n" : "";
        return resultString;
    }

    function getLestCoordinatesString() {
        let returnString = "";
        returnString += (geodeticLocationData.xyKoht ? geodeticLocationData.x?.toFixed(geodeticLocationData.xyKoht): geodeticLocationData.x) + " ";
        returnString += (geodeticLocationData.xyKoht ? geodeticLocationData.y?.toFixed(geodeticLocationData.xyKoht): geodeticLocationData.y);
        returnString += isResultFromTransform() ? " (" + t('singleTransformResult') + ") | " : " | ";
        returnString += geodeticLocationData.klassXy + " | ";
        returnString += t('singleJobName') + ": " + geodeticLocationData.tooNim + " | "
        returnString += (geodeticLocationData.aasta1 ? geodeticLocationData.aasta1 : "") + " " + ((geodeticLocationData.aasta1 !== geodeticLocationData.aasta2) ? (geodeticLocationData.aasta1 != null ? " - " : "") + geodeticLocationData.aasta2 : "");
        if (geodeticLocationData.aruSu !== null && geodeticLocationData.aruSu?.toString().trim() !== "") {
            returnString += " | " + t('singleArchiveNumber') + ": " + geodeticLocationData.aruSu;                
        }
        return returnString;
    }

    function getEh2000String() {
        let returnString = "";
        if (geodeticLocationData.eh2000 !== null) {
            returnString += parseFloat(geodeticLocationData.eh2000?.toString()).toFixed(geodeticLocationData.korgusKoht ? geodeticLocationData.korgusKoht : 4); // + (isYleminekuMudel() ? " (arvutatud BK77->EH2000 üleminekumudelist)" : "");
            returnString += isYleminekuMudel() ? " (" + t('singleBK77ToEH2000TransitionalModelResult') + ")" : "";
            returnString += geodeticLocationData.klassZ ? " | " + geodeticLocationData.klassZ : "";
            returnString += geodeticLocationData.tooNimKorgus ? " | " + t('singleJobName') + ": " + geodeticLocationData.tooNimKorgus : "";
    
            if (geodeticLocationData.aasta1Korgus) {
                returnString += " | " + geodeticLocationData.aasta1Korgus;
                if (geodeticLocationData.aasta2Korgus !== null && geodeticLocationData.aasta1Korgus !== geodeticLocationData.aasta2Korgus) {
                    returnString += " - " + geodeticLocationData.aasta2Korgus;
                } 
            }    
            returnString += (geodeticLocationData.aruSuKorgus !== null && geodeticLocationData.aruSuKorgus?.toString().trim() !== "") ? " | " + t('singleArchiveNumber') + ": " + geodeticLocationData.aruSuKorgus : "";
        } else {
            returnString += parseFloat((geodeticLocationData.elk97-geodeticLocationData.ellips)?.toString()).toFixed(geodeticLocationData.elk97Koht ? geodeticLocationData.elk97Koht : 3) + " (" + t('singleGeoidModelResult') + ")";
        }


        return returnString;
    }

    function getElk97String() {
        let returnString = "";
        returnString += parseFloat(geodeticLocationData.elk97?.toString()).toFixed(geodeticLocationData.elk97Koht ? geodeticLocationData.elk97Koht : 3);
        returnString += geodeticLocationData.klassElk97 ? " | " + geodeticLocationData.klassElk97 : "";
        returnString += geodeticLocationData.tooNimElk97 ? " | " + t('singleJobName') + ": " + geodeticLocationData.tooNimElk97 : "";

        if (geodeticLocationData.aasta1Elk97) {
            returnString += " | " + geodeticLocationData.aasta1Elk97;
            returnString += (geodeticLocationData.aasta2Elk97 !== null && geodeticLocationData.aasta1Elk97 !== geodeticLocationData.aasta2Elk97) ? " - " + geodeticLocationData.aasta2Elk97 : "";
        }

        returnString += (geodeticLocationData.aruSuElk97 !== null && geodeticLocationData.aruSuElk97?.toString().trim() !== "") ? " | " + t('singleArchiveNumber') + ": " + geodeticLocationData.aruSuElk97 : "";

        return returnString;
    }

    function getGravimetricMeasurements() {
        let returnString = "";

        returnString += geodeticLocationData.rkRkiirendus ? geodeticLocationData.rkRkiirendus : "";
        returnString += geodeticLocationData.rkNvaliArvut ? " | " + t('singleNormalField') + ": " + geodeticLocationData.rkNvaliArvut.toFixed(3) + (geodeticLocationData.rkNvali ? " (" + geodeticLocationData.rkNvali + ") " : "") : "";
        returnString += geodeticLocationData.rkBouguerArvut ? " | " + t('singleBouguerAnomaly') + ": " + geodeticLocationData.rkBouguerArvut.toFixed(3) + (geodeticLocationData.rkBouguer ? " (" + geodeticLocationData.rkBouguer + ") " : "") : "";
        returnString += geodeticLocationData.rkVabaArvut ? " | " + t('singleOpenAirAnomaly') + ": " + geodeticLocationData.rkVabaArvut.toFixed(3) + (geodeticLocationData.rkVaba ? " (" + geodeticLocationData.rkVaba + ") " : "") : "";
        returnString += geodeticLocationData.klassGr ? " | " + geodeticLocationData.klassGr : "";
        returnString += geodeticLocationData.rkTooNim ? " | " + t('singleJobName') + ": " + geodeticLocationData.rkTooNim : "";
        returnString += geodeticLocationData.rkAasta1 ? " | " + geodeticLocationData.rkAasta1 : "";
        returnString += geodeticLocationData.rkAruSu ? " | " + t('singleArchiveNumber') + ": " + geodeticLocationData.rkAruSu : "";

        return returnString;
    }

    function isResultFromTransform() {
        /*„artskode_xy“ ei ole 1, 2, 3, 4, 5, 6, 35, 36, 37, 41, 42, 43, 44, 62 või 64*/
        return (geodeticLocationData.artskodeXy !== 1 &&
            geodeticLocationData.artskodeXy !== 2 &&
            geodeticLocationData.artskodeXy !== 3 &&
            geodeticLocationData.artskodeXy !== 4 &&
            geodeticLocationData.artskodeXy !== 5 &&
            geodeticLocationData.artskodeXy !== 6 &&
            geodeticLocationData.artskodeXy !== 35 &&
            geodeticLocationData.artskodeXy !== 36 &&
            geodeticLocationData.artskodeXy !== 37 &&
            geodeticLocationData.artskodeXy !== 41 &&
            geodeticLocationData.artskodeXy !== 42 &&
            geodeticLocationData.artskodeXy !== 43 &&
            geodeticLocationData.artskodeXy !== 43 &&
            geodeticLocationData.artskodeXy !== 44 &&
            geodeticLocationData.artskodeXy !== 45 &&
            geodeticLocationData.artskodeXy !== 46 &&
            geodeticLocationData.artskodeXy !== 62 &&
            geodeticLocationData.artskodeXy !== 64);
    }

    return (
        <>
        <Table striped bordered responsive>
            <tbody>
                <tr>
                    <td style={{ width: "200px" }}>{t('resultId')}</td>
                    <td>{geodeticLocationData.refNrId}</td>
                </tr>
                <tr>
                    <td>
                        {t('resultPointNumber')}
                    </td>
                    <td>
                        {geodeticLocationData.lbn}
                    </td>
                </tr>
                <tr>
                    <td>
                        {t('resultName')}
                    </td>
                    <td>
                        {geodeticLocationData.nimi}
                    </td>
                </tr>
                <tr>
                    <td>
                        {t('resultCode')}
                    </td>
                    <td>
                        {geodeticLocationData.hnr}-{geodeticLocationData.snr}-{geodeticLocationData.lbn}
                    </td>
                </tr>
                <tr>
                    <td>
                        {t('resultPlaneTrCoords')} x<sub>L-EST97</sub> ja y<sub>L-EST97</sub>
                    </td>
                    <td>
                        {getLestCoordinatesString()}
                    </td>
                </tr>
                <tr>
                    <td>
                        {t('resultGeodeticCoords')} B<sub>EUREF-EST97</sub> ja L<sub>EUREF-EST97</sub>
                    </td>
                    <td>
                        {getDegrees(geodeticLocationData.b)} {getDegrees(geodeticLocationData.l)}<br/>
                        {geodeticLocationData.b} {geodeticLocationData.l}
                    </td>
                </tr>

                {(geodeticLocationData.eh2000 || (geodeticLocationData.elk97 && geodeticLocationData.ellips)) && 
                    <tr>
                        <td>
                            {t('resultNormHeight')}<sub>EH2000</sub>
                        </td>
                        <td>
                            {getEh2000String()}
                        </td>
                    </tr>
                }

                {geodeticLocationData.elk97 &&
                    <tr>
                        <td>
                            {t('resultEllipsoidHeight')}<sub>EUREF-EST97</sub>
                        </td>
                        <td>
                            {getElk97String()}
                        </td>
                    </tr>
                }

                {(geodeticLocationData.rkRkiirendus || geodeticLocationData.rkNvaliArvut || geodeticLocationData.rkBouguerArvut || geodeticLocationData.rkVabaArvut) &&
                    <tr>
                        <td>
                            {t('resultGrAcceleration')}<sub>EG2000</sub>
                        </td>
                        <td>
                            {getGravimetricMeasurements()}
                        </td>
                    </tr>
                }

                <tr>
                    <td>
                        {t('resultCondition')}
                    </td>
                    <td>
                        {geodeticLocationData.skoodTxt} {(geodeticLocationData.skood && geodeticLocationData.skood !== 0) ? ((geodeticLocationData.ulevKuupaev && geodeticLocationData.ulevKuupaev !== "0" ) ? geodeticLocationData.ulevKuupaev : "") + " " + (geodeticLocationData.ulevFirma ? geodeticLocationData.ulevFirma : "") : ""}
                        {(geodeticLocationData.smarkus !== null && geodeticLocationData.smarkus.trim() !== "") &&
                            <>{" | "} {geodeticLocationData.smarkus}</>
                        }
                    </td>
                </tr>
                {geodeticLocationData.gpsSobivTxt != null &&
                    <tr>
                        <td>
                            {t('resultGNSSCompatibility')}
                        </td>
                        <td>
                            {geodeticLocationData.gpsSobivTxt}
                        </td>
                    </tr>
                }
                {(geodeticLocationData.tuupKood !== null && geodeticLocationData.tuupKood > 0) && 
                    <tr>
                        <td>
                            {t('resultMarkerType')}
                        </td>
                        <td>
                            {geodeticLocationData.tuupKood}
                        </td>
                    </tr>
                }
                {geodeticLocationData.kaitsevoondTxt != null &&
                    <tr>
                        <td>
                            {t('resultProtectionArea')}
                        </td>
                        <td>
                            {geodeticLocationData.kaitsevoondTxt}
                        </td>
                    </tr>
                }
                {geodeticLocationData.asustusyksus != null &&
                    <tr>
                        <td>
                            {t('resultSettlemUnit')}
                        </td>
                        <td>
                            {geodeticLocationData.asustusyksus}
                        </td>
                    </tr>
                }

                {geodeticLocationData.kirjeldus &&
                    <tr>
                        <td>
                            {t('resultLocationDescription')}
                        </td>
                        <td>
                            {geodeticLocationData.kirjeldus}
                        </td>
                    </tr>
                }
            </tbody>

        </Table>

        <DownloadLink 
            style={{
                color: "#fff",
                backgroundColor: "#0d6efd",
                borderColor: "#0d6efd",
                display: "inline-block",
                fontWeight: "400",
                lineHeight: "1.5",
                textAlign: "center",
                textDecoration: "none",
                verticalAlign: "middle",
                border: "1px solid transparent",
                padding: "0.375rem 0.75rem",
                fontSize: "1rem",
                borderRadius: "0.25rem",
                userSelect: "none",
                transition: "color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out"
            }} 
            tagName="button" 
            label={t('singleDownloadDataAsTextFile').toString()} 
            filename={"Punkt" + geodeticLocationData.refNrId + ".txt"} 
            exportFile={() => generateInfoFile()} 
        />
        {" "}
        <Button onClick={(e) => coordinatesSearchClicked(e.nativeEvent)} type="submit">{t('singleFindPointsInRadiusButtonLabel')}</Button>
        {" "}
        {geodeticLocationData.piltImageInfo?.length > 0 &&
            <ImageModal pictureIds={geodeticLocationData.piltImageInfo} table="pilt" />
        }
        {geodeticLocationData.panoraamImageInfo?.length > 0 &&
            <ImageModal pictureIds={geodeticLocationData.panoraamImageInfo} table="pan" />
        }
        {geodeticLocationData.sidemedImageInfo?.length > 0 &&
            <ImageModal pictureIds={geodeticLocationData.sidemedImageInfo} table="sidemed" />
        }
        {geodeticLocationData.tuupjoonisImageInfo?.length > 0 &&
            <ImageModal pictureIds={geodeticLocationData.tuupjoonisImageInfo} table="tuupjoonis" />
        }

</>
    );
}

export default SinglePointDataTable